import React from "react";
import { Input, Box } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { useAsyncDebounce } from "react-table";

interface MobileSearchProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  placeholder?: string;
  count?: number;
}

const MobileSearch: React.FC<MobileSearchProps> = ({
  searchValue,
  onSearchChange,
  placeholder,
  count,
}) => {
  const { t } = useTranslation("common");
  const [value, setValue] = React.useState(searchValue);

  const onChange = useAsyncDebounce((value) => {
    onSearchChange(value || "");
  }, 200);

  return (
    <Box w="100%" mb={2}>
      <Input
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder={placeholder || t("searchRecords", { count: count || 0 })}
        borderRadius="md"
        w="100%"
      />
    </Box>
  );
};

export default MobileSearch;
